// extracted by mini-css-extract-plugin
export default {"my_select_wrapper":"CustomSelectWithMui_my_select_wrapper__ikCiD","my_select":"CustomSelectWithMui_my_select__7PeK4","label":"CustomSelectWithMui_label__DSgfp"};